import React from 'react'
import withUser from 'components/withUser'
import FormForRecord from 'components/FormForRecord'
import fields from 'fields/users'
import updateUserMutation from 'graphs/mutations/updateUser.graphql'
import userValidation from 'validations/user'

const RouteEdit = ({ user, history: { goBack } }) => (
  <FormForRecord
    record={user}
    mutation={updateUserMutation}
    onSuccess={goBack}
    onCancel={goBack}
    fields={fields}
    variables={{ id: user.id }}
    schema={userValidation}
    title="Edit User Information"
  />
)

export default withUser(RouteEdit)



// WEBPACK FOOTER //
// ./src/routes/admin/users/edit.js